<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
      <!--begin::sidebar-->
      <sidebar-component classMenu="PointersOfMonthAdd"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            "
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    Add Pointer of Month
                  </h6>
                  <button
                    class="btn btn-default btn-sm float-end"
                    @click="resetForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>
                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <!--end::loading-data-->

                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-between
                        align-items-baseline
                        mb-2
                      "
                    ></div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="user_search"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >User</label
                        >
                      </div>
                      
                      <div class="col-lg-8">
                        <!-- Search Input -->
                        <div class="position-relative">
                          <input
                            type="text"
                            class="form-control"
                            id="user_search"
                            v-model="userSearch"
                            @input="searchUsers"
                            @focus="showUserDropdown = true"
                            placeholder="Search users by name or email..."
                            autocomplete="off"
                          />
                          <i class="mdi mdi-magnify position-absolute" style="right: 10px; top: 50%; transform: translateY(-50%); color: #6c757d;"></i>
                        </div>

                        <!-- Dropdown Results -->
                        <div 
                          v-if="showUserDropdown && (filteredUsers.length > 0 || userSearchLoading)"
                          class="dropdown-menu show w-100 mt-1"
                          style="max-height: 300px; overflow-y: auto; position: absolute; z-index: 1000;"
                        >
                          <!-- Loading State -->
                          <div v-if="userSearchLoading" class="dropdown-item text-center">
                            <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                            Searching users...
                          </div>
                          
                          <!-- No Results -->
                          <div v-else-if="filteredUsers.length === 0 && userSearch.length > 0" class="dropdown-item text-muted">
                            No users found matching "{{ userSearch }}"
                          </div>
                          
                          <!-- User Results -->
                          <a 
                            v-for="user in filteredUsers" 
                            :key="user.id"
                            href="#"
                            class="dropdown-item d-flex align-items-center"
                            @click.prevent="selectUser(user)"
                          >
                            <img
                              :src="getUserImage(user)"
                              alt="User"
                              class="rounded-circle me-2"
                              style="width: 32px; height: 32px; object-fit: cover"
                            />
                            <div>
                              <div class="fw-medium">{{ user.name }}</div>
                              <small class="text-muted">{{ user.email }}</small>
                            </div>
                          </a>
                        </div>

                        <!-- Selected User Display -->
                        <div v-if="selectedUser" class="mt-2 p-2 border rounded bg-light">
                          <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center">
                              <img
                                :src="getUserImage(selectedUser)"
                                alt="Selected User"
                                class="rounded-circle me-2"
                                style="width: 40px; height: 40px; object-fit: cover"
                              />
                              <div>
                                <div class="fw-medium">{{ selectedUser.name }}</div>
                                <small class="text-muted">{{ selectedUser.email }}</small>
                              </div>
                            </div>
                            <button 
                              type="button" 
                              class="btn btn-sm btn-outline-danger"
                              @click="clearSelectedUser"
                            >
                              <i class="mdi mdi-close"></i>
                            </button>
                          </div>
                        </div>

                        <!-- Hidden input for form submission -->
                        <input type="hidden" v-model="forms.user_id" required />

                        <div v-if="errors.user_id">
                          <div
                            v-for="error in errors.user_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="month_year"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Month/Year</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="month"
                          class="form-control"
                          id="month_year"
                          v-model="forms.month_year"
                          required
                        />
                        <div v-if="errors.month_year">
                          <div
                            v-for="error in errors.month_year"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="description"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Description</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <textarea
                          class="form-control"
                          id="description"
                          rows="4"
                          placeholder="Optional description"
                          v-model="forms.description"
                        ></textarea>
                        <div v-if="errors.description">
                          <div
                            v-for="error in errors.description"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="custom_image"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Custom Image</label
                        > 
                      </div>
                      <div class="col-lg-8">
                        <div v-if="images_temporary" class="dropify-wrapper has-preview">
                          <div class="dropify-message"> 
                            <span class="file-icon" v-if="!images_temporary"> 
                              <p>Drag and drop a file here or click</p>
                            </span>
                            <p class="dropify-error">Ooops, something wrong appended.</p>
                          </div>
                          <div class="dropify-loader" style="display: none;"></div>
                          <div class="dropify-errors-container">
                            <ul></ul>
                          </div>
                          <input type="file" ref="custom_image" accept="image/*" class="form-control" @change="handleFileUpload($event)">
                          <button type="button" class="dropify-clear" @click="removeImages">Remove</button>
                          <div  class="dropify-preview" style="display: block;">
                            <img :src="images_temporary" width="90%" height="80%"/>
                          <span class="dropify-render"></span>
                          <div class="dropify-infos">
                            <div class="dropify-infos-inner">
                              <p class="dropify-filename">
                              </p><p class="dropify-infos-message">Drag and drop or click to replace</p>
                            </div>
                          </div>
                          </div>
                          
                          </div>
                        <div v-else class="dropify-wrapper">
                          <div class="dropify-message"> 
                            <span class="file-icon"> 
                              <p>Drag and drop a file here or click (Optional - will use user profile image if not provided)</p>
                            </span>
                          </div>
                          <div class="dropify-loader" style="display: none;"></div>
                          <div class="dropify-errors-container">
                            <ul></ul>
                          </div>
                          <input type="file" ref="custom_image" accept="image/*" class="form-control" @change="handleFileUpload($event)">
                          <button type="button" class="dropify-clear">Remove</button>
                          <div class="dropify-preview" style="display: none;">
                            <img :src="images_temporary" width="90%" height="80%"/>
                          <span class="dropify-render"></span>
                          <div class="dropify-infos">
                            <div class="dropify-infos-inner">
                              <p class="dropify-filename">
                              </p><p class="dropify-infos-message">Drag and drop or click to replace</p>
                            </div>
                          </div>
                          </div>
                          
                          </div>

                        <div v-if="errors.custom_image">
                          <div
                            v-for="error in errors.custom_image"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit"
                      >
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>

                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "PointersOfMonthAdd",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {      
      isLoading: false,      
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      permision_role: [],
      userData: "",
      forms: {},
      users: [],
      filteredUsers: [],
      selectedUser: null,
      userSearch: '',
      showUserDropdown: false,
      userSearchLoading: false,
      searchTimeout: null,
      custom_image: '',
      images_temporary: null,
    };
  },
  watch: {},
  methods: {
    removeImages(){
      this.$refs.custom_image.value="";
      this.images_temporary = null;
    },

    handleFileUpload(event) {
      this.custom_image = event.target.files[0];
      this.images_temporary = URL.createObjectURL(this.custom_image);
    },

    resetForm() {      
      this.forms.user_id = "";
      this.forms.month_year = "";
      this.forms.description = "";
      this.selectedUser = null;
      this.userSearch = "";
      this.showUserDropdown = false;
      this.removeImages();
    },

    getUserImage(user) {
      if (user?.image) {
        return user.image;
      }
      return require('@/assets/maternity.png');
    },

    searchUsers() {
      // Clear previous timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      // If search is empty, hide dropdown
      if (this.userSearch.trim().length === 0) {
        this.showUserDropdown = false;
        this.filteredUsers = [];
        return;
      }

      // Show loading state
      this.userSearchLoading = true;
      this.showUserDropdown = true;

      // Debounce search to avoid too many API calls
      this.searchTimeout = setTimeout(() => {
        this.performUserSearch();
      }, 300);
    },

    performUserSearch() {
      const baseURI = this.$settings.endPoint + "pointers-of-month/users";
      
      this.$http
        .get(baseURI, {
          params: {
            search: this.userSearch.trim()
          }
        })
        .then((response) => {
          this.userSearchLoading = false;
          if (response.data.status === 200) {
            this.filteredUsers = response.data.datas;
          } else {
            this.filteredUsers = [];
          }
        })
        .catch((error) => {
          this.userSearchLoading = false;
          this.filteredUsers = [];
          console.error("Error searching users:", error);
        });
    },

    selectUser(user) {
      this.selectedUser = user;
      this.forms.user_id = user.id;
      this.userSearch = user.name;
      this.showUserDropdown = false;
      this.filteredUsers = [];
    },

    clearSelectedUser() {
      this.selectedUser = null;
      this.forms.user_id = "";
      this.userSearch = "";
      this.showUserDropdown = false;
      this.filteredUsers = [];
    },

    // Close dropdown when clicking outside
    handleClickOutside(event) {
      const dropdown = event.target.closest('.position-relative');
      if (!dropdown) {
        this.showUserDropdown = false;
      }
    },

    backForm() {
      window.location.href = "/pointers-of-month";
    },

    fetchUsers() {
      const baseURI = this.$settings.endPoint + "pointers-of-month/users";
      this.$http
        .get(baseURI)
        .then((response) => {
          if (response.data.status === 200) {
            this.users = response.data.datas;
          }
        })
        .catch((error) => {
          console.error("Error fetching users:", error);
        });
    },

    submitData() {
      this.isLoading = true
      let formData = new FormData();
 
      if (this.custom_image) {
        formData.append("custom_image", this.custom_image);
      }
      formData.append("user_id", this.forms.user_id);
      formData.append("month_year", this.forms.month_year);
      formData.append("description", this.forms.description || "");

      const baseURI = this.$settings.endPoint + "pointers-of-month/create";
      this.$http
        .post(baseURI, formData,{ timeout: 10000 })
        .then((response) => {
           this.isLoading = false
          if (response.data.status === 200) {
            this.errors = [];
            var params = this.$onRandom(response.data.datas.id);
            window.location.href = "/pointers-of-month/detail/" + params + "?status=200&msg=Successfully";
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        }).catch(error => {
          this.isLoading = false;
          if(error.code == "ECONNABORTED"){
            this.error("Please Check Your Internet Connection");
          }else{

            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.error(error.response.data.errors.message);
              } else {
                this.$router.push("/page-not-found");
              }
            }
            
          }
        });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000);
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "PointersOfMonthController") {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_create) {
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.fetchUsers();
    
    // Add event listener for clicking outside dropdown
    document.addEventListener('click', this.handleClickOutside);
  },
  
  beforeDestroy() {
    // Remove event listener when component is destroyed
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style scoped>
button.gm-ui-hover-effect {
  visibility: hidden;
}

.blur-content{
  filter: blur(5px); 
  pointer-events: none;
}
</style>